module.exports = __webpack_public_path__ + "img/28.780dd85a.png";